import './InitialStepForm.scss';
import 'sass/blocks/_age-restriction.scss';
import 'sass/blocks/_resident-restriction.scss';
import 'sass/blocks/_dni-deny.scss';
import 'sass/blocks/_password-requirements.scss';
import 'sass/blocks/_initial-step.scss';
import 'sass/animations.scss';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SECTION_TYPE } from '../constants';
import { useSections } from '../useSections';
import { PersonalData } from '../sections/PersonalData/PersonalData';
import { AccessData } from '../sections/AccessData/AccessData';
import { PrecontractualDocs } from '../sections/PrecontractualDocs/PrecontractualDocs';
import { EmailOTPValidation } from '../sections/EmailOTPValidation/EmailOTPValidation';
import { useUserProfileInitialization } from './hooks/useUserProfileInitialization';
import { useLastSectionValidationAndRegister } from './hooks/useLastSectionValidationAndRegister';
import { useUpdateOnboardingTypeByPromotionalCode } from './hooks/useUpdateOnboardingTypeByPromotionalCode';
import { useResetSectionsAfterOnboardingTypeChange } from 'components/newAccountSteps/initialStep/InitialStepForm/hooks/useResetSectionsAfterOnboardingTypeChange';
import { useGetDefaultProducts } from 'components/newAccountSteps/initialStep/InitialStepForm/hooks/useGetDefaultProducts';
import { useInitialStepForm } from './context/InitialStepFormContext/InitialStepFormContext';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { withCaptcha } from 'hocs/withCaptcha/withCaptcha';
import { actions as formActions } from 'react-redux-form';
import actions from 'actions/initialActions';
import productsActions from 'actions/productsActions';
import focusActions from 'actions/focusActions';
import preLoaderActions from 'actions/preLoaderActions';
import optionsActions from 'actions/optionsActions';

const { ACCESS_DATA, EMAIL_OTP_VALIDATION, PERSONAL_DATA, PRECONTRACTUAL_DOCS } = SECTION_TYPE;

export const InitialStepFormComponent = ({
    flags,
    actions,
    focus,
    formActions,
    preLoaderActions,
    productsActions,
    promotionalCode,
    readyCaptchaToken,
    userProfile,
    userProfileForm,
    options,
    optionsActions,
    initialStateSections,
    renderTermsAndConditions,
}) => {
    const { isAdviseShown } = useInitialStepForm();

    useUserProfileInitialization({ userProfile, formActions });

    useUpdateOnboardingTypeByPromotionalCode({ promotionalCode, formActions });

    const {
        state,
        validatePersonalDataSection,
        validateAccessDataSection,
        validatePrecontractualDocsSection,
        validateOTPValidationSection,
        modifyPersonalDataSection,
        modifyPrecontractualDocsSection,
        modifyEmailOTPSection,
        modifyAccessDataSection,
        resetPrecontractualDocsSection,
        resetEmailOTPSection,
        resetAccessDataSection,
    } = useSections(initialStateSections);

    const { handleValidationAndRegister } = useLastSectionValidationAndRegister({
        flags,
        userProfile,
        userProfileForm,
        validateSection: validateAccessDataSection,
        actions,
        preLoaderActions,
        readyCaptchaToken,
    });

    useResetSectionsAfterOnboardingTypeChange({
        isPersonalDataCompleted: state[PERSONAL_DATA].isCollapsed && state[PERSONAL_DATA].isValidated,
        resetPrecontractualDocsSection,
        resetEmailOTPSection,
        resetAccessDataSection,
        modifyPrecontractualDocsSection,
        formActions,
        onboardingType: userProfile.onboardingType,
    });

    useGetDefaultProducts(userProfile, productsActions.getProducts);

    const promoCode = promotionalCode?.get('promotionalCode')?.get('code');

    return (
        <div className="initial-step-form-content">
            <PersonalData
                actions={actions}
                focus={focus}
                formActions={formActions}
                isCollapsed={state[PERSONAL_DATA].isCollapsed}
                isValidated={state[PERSONAL_DATA].isValidated}
                options={options}
                optionsActions={optionsActions}
                promoCode={promoCode}
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                handleModifySection={modifyPersonalDataSection}
                handleValidateSection={validatePersonalDataSection}
            />
            {!isAdviseShown && (
                <>
                    <PrecontractualDocs
                        actions={actions}
                        formActions={formActions}
                        handleModifySection={modifyPrecontractualDocsSection}
                        handleValidateSection={validatePrecontractualDocsSection}
                        isPersonalDataCompleted={state[PERSONAL_DATA].isCollapsed && state[PERSONAL_DATA].isValidated}
                        isCollapsed={state[PRECONTRACTUAL_DOCS].isCollapsed}
                        isValidated={state[PRECONTRACTUAL_DOCS].isValidated}
                        preLoaderActions={preLoaderActions}
                        promotionalCode={promotionalCode}
                        readyCaptchaToken={readyCaptchaToken}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                    />
                    <EmailOTPValidation
                        formActions={formActions}
                        handleModifySection={modifyEmailOTPSection}
                        handleValidateSection={validateOTPValidationSection}
                        isCollapsed={state[EMAIL_OTP_VALIDATION].isCollapsed}
                        isValidated={state[EMAIL_OTP_VALIDATION].isValidated}
                        preLoaderActions={preLoaderActions}
                        promoCode={promoCode}
                        readyCaptchaToken={readyCaptchaToken}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                    />
                    <AccessData
                        formActions={formActions}
                        handleModifyID={modifyPersonalDataSection}
                        handleModifySection={modifyAccessDataSection}
                        handleValidateSection={handleValidationAndRegister}
                        isCollapsed={state[ACCESS_DATA].isCollapsed}
                        isValidated={state[ACCESS_DATA].isValidated}
                        promoCode={promoCode}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                        renderTermsAndConditions={renderTermsAndConditions}
                    />
                </>
            )}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        focus: state.focus,
        preLoader: state.preLoader,
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    focusActions: bindActionCreators(focusActions, dispatch),
    formActions: bindActionCreators(formActions, dispatch),
    preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    productsActions: bindActionCreators(productsActions, dispatch),
    optionsActions: bindActionCreators(optionsActions, dispatch),
});

export const InitialStepForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(withCaptcha(withFeatureToggling(InitialStepFormComponent)));
